import {Card, Tag} from '@vector';
import {GamepadBoldIcon} from '@solar-icons/react';
import styles from './LessonCard.module.css';

const TONES = ['accent', 'secondary', 'raised', 'base'];

export default function LessonCard({lesson, index}) {
    const tone = TONES[index % TONES.length];
    const dark = tone === 'inverse';
    const number = String(index + 1).padStart(2, '0');

    return (
        <Card
            as="a"
            href={`/usersCommon/publicLogin.action?syllabusId=${lesson.syllabusId}`}
            surface={tone}
            className={styles.card}
            style={{color: dark ? 'var(--color-text-on-brand)' : 'var(--color-text-primary)'}}>
            <div className={styles.top}>
                <span className={styles.number}>{number}</span>
                {lesson.includesGames && (
                    <Tag variant="solid" color="default" icon={<GamepadBoldIcon size={14}/>}>
                        Includes games
                    </Tag>
                )}
            </div>
            <div className={styles.body}>
                <span className={styles.meta}>{lesson.level} {'·'} {lesson.topic}</span>
                <span className={styles.title}>{lesson.title}</span>
            </div>
            <span className={styles.footer}>View lesson</span>
        </Card>
    );
}
